import _typeof from '@babel/runtime/helpers/typeof';

function _isPlaceholder(a) {
  return a != null && _typeof(a) === 'object' && a['@@functional/placeholder'] === true;
}

export { _isPlaceholder as default };
